module.exports = __webpack_public_path__ + "img/reset.25fb2fc0.svg";